import { apiClient } from "./apiclient";

// Reuses the existing /api/daily-report backend (used by Daily Reporting page).
// Returns a flat list of entries; MyReports page groups them by date on the frontend.
export const getMyReports = (token, { userInfoId, fromDate, toDate }) =>
  apiClient.get("/api/daily-report/by-user-date-range", {
    headers: { Authorization: `Bearer ${token}` },
    params: {
      userInfoId,
      ...(fromDate && { fromDate }),
      ...(toDate && { toDate }),
    },
  });
  